import script from "./ManageTypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageTypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./ManageTypeFilter.vue?vue&type=style&index=0&id=4b5fbeb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5fbeb8"]])

export default __exports__